import { http } from '../../../../api/http';
import type { PeriodoPlanilla } from '../types/periodo';

const ENDPOINT = '/planilla/periodo';

export class PeriodoService {
  public static async getAll(): Promise<PeriodoPlanilla[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  public static async getById(id: number): Promise<PeriodoPlanilla> {
    const response = await http.get(`${ENDPOINT}/${id}`);
    return response.data;
  }

  public static async getActivo(): Promise<PeriodoPlanilla | null> {
    try {
      const response = await http.get(`${ENDPOINT}/activo`);
      return response.data;
    } catch {
      return null;
    }
  }

  public static async create(periodo: PeriodoPlanilla): Promise<PeriodoPlanilla> {
    const response = await http.post(ENDPOINT, periodo);
    return response.data;
  }

  public static async updateEstado(id: number, estado: string): Promise<PeriodoPlanilla> {
    const response = await http.put(`${ENDPOINT}/${id}/estado`, { estado });
    return response.data;
  }

  public static async generarSemanales(anio: number, valorUIT: number, valorRMV: number) {
    const response = await http.post(`${ENDPOINT}/generar-semanales`, { anio, valorUIT, valorRMV });
    return response.data;
  }

  public static async generarQuincenales(anio: number, mes: number, valorUIT: number, valorRMV: number) {
    const response = await http.post(`${ENDPOINT}/generar-quincenales`, { anio, mes, valorUIT, valorRMV });
    return response.data;
  }
}
